import axios from 'axios'

const defaultInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_URL,
  // headers: {
  //   Authorization: `Bearer ${localStorage.getItem('token')}`,
  // },
})

// Add a request interceptor
defaultInstance.interceptors.request.use(
  (config) => {
    // Do something before request is sent

    // console.log('request_config', config)

    const token = localStorage.getItem('token')
    const auth = token ? `Bearer ${token}` : ''
    console.log('config', config)
    config.headers.common['Authorization'] = auth

    config.metadata = { startTime: new Date() }

    if (config.trailingSlash && config.url[config.url.length - 1] !== '/') {
      config.url += '/'
    }

    return config
  },
  (error) => {
    // Do something with request error

    // console.log('request_error', error)

    return Promise.reject(error)
  }
)

// Add a response interceptor
defaultInstance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    // console.log('response', response)

    response.config.metadata.endTime = new Date()
    response.duration = response.config.metadata.endTime - response.config.metadata.startTime

    return response
  },
  async (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    // console.log('response_error', error)

    error.config.metadata.endTime = new Date()
    error.duration = error.config.metadata.endTime - error.config.metadata.startTime

    if (error.response) {
      console.log('error.response', error?.response?.data?.detail)
      if (
        error?.response?.data?.detail === 'Unauthorized JWT' ||
        error?.response?.data?.detail === 'Not authenticated'
      ) {
        localStorage.setItem('isLogin', false)
        window.location.reload()
      }
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log('error.response', error.response)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // console.log('error.request', error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.log('Error', error.message)
    }

    // console.log('error.config', error.config)

    return Promise.reject(error)
  }
)

export { defaultInstance }
